import { useContext } from 'react';
import { FileUploadEffectsContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useFileUploadEffects = () => {
  const effects = useContext(FileUploadEffectsContext);

  return effects;
};

export default useFileUploadEffects;